import React from "react";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

export default function PhoneInputField({
  value,
  onChange,
  country, // default Nigeria
}) {
  const prefix = `+${getCountryCallingCode(country)}`;
  const Flag = flags[country];

  return (
    <div className="space-y-2">
      <label className="block text-sm font-semibold text-gray-700">
        Phone Number
      </label>
      <div className="flex items-center border rounded-md overflow-hidden">
        {/* Prefix with Flag */}
        <div className="flex items-center bg-gray-100 px-3 py-2 border-r">
          {Flag && <Flag className="w-5 h-5 mr-2" />}
          <span className="text-gray-700 font-medium">{prefix}</span>
        </div>

        {/* Editable number input */}
        <input
          type="tel"
          value={value}
          onChange={onChange}
          readOnly={false}
          className="flex-1 px-3 py-2 outline-none"
          placeholder="812 345 6789"
        />
      </div>
    </div>
  );
}
